import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

export const customColors = {
    primary: "#ec008c",
    secondary: "#4a148c",
    tertiary: "#fcd13a",
};

// TODO: REMOVE (PROP disableRipple:true on MuiButtonBase AND
//  OVERRIDES underline on MuiInput, focusVisible on MuiButtonBase))
// WHEN https://bugs.chromium.org/p/chromium/issues/detail?id=992010 fixed
export const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: customColors.primary,
        },
        secondary: {
            main: customColors.secondary,
        },
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    typography: {
        fontFamily: "Swiss-721-Greek-BT",
    },
    overrides: {
        MuiTypography: {
            body1: {
                fontSize: "0.9em",
                fontWeight: 100,
                color: customColors.secondary,
            },
            body2: {
                fontSize: "0.9em",
                fontWeight: 100,
                color: customColors.secondary,
            },
            h1: {
                fontSize: "2.9em",
                fontWeight: 800,
            },
            h2: {
                fontSize: "2em",
                fontWeight: 800,
            },
            h3: {
                fontSize: "1.9em",
                fontWeight: 800,
            },
            h4: {
                fontSize: "1.6em",
                fontWeight: 400,
            },
            h5: {
                fontSize: "1em",
                fontWeight: 400,
            },
            h6: {
                fontSize: 20,
                fontWeight: 500,
                color: "white",
            },
            subtitle1: {
                fontSize: 16,
                fontWeight: 500,
            },
            subtitle2: {
                fontSize: 17,
                fontWeight: 400,
            },
            overline: {
                fontSize: 15,
                fontWeight: 100,
                lineHeight: "18px",
            },
        },
        MuiPaper: {
            rounded: {
                borderRadius: "10px",
            },
            elevation2: {
                boxShadow:
                    "0px 0px 8px 0px rgba(0, 0, 0, 0)," +
                    "0px 0px 4px 0px rgba(0, 0, 0, 0), " +
                    "0px 0px 7px 2px rgba(0, 0, 0, 0.11);",
            },
        },
        MuiFab: {
            root: {
                boxShadow: "none",
            },
            secondary: {
                color: customColors.tertiary,
            },
        },
        MuiButtonBase: {
            root: {
                "&$focusVisible": {
                    outline: "auto 5px -webkit-focus-ring-color !important",
                },
            },
        },
        MuiButton: {
            root: {
                textTransform: "initial",
                borderRadius: "30px",
            },
            contained: {
                boxShadow: "none",
            },
            outlined: {
                boxShadow: "none",
            },
        },
        MuiCardHeader: {
            content: {
                zIndex: 10,
            },
        },
        MuiCardContent: {
            root: {
                overflow: "hidden",
                "&:last-child": {
                    paddingBottom: "16px",
                },
            },
        },
        MuiSelect: {
            filled: {
                borderRadius: "41px",
                backgroundColor: "white",
                boxShadow: "0px 0px 12px 0px rgba(8, 68, 164, 0.14)",
                paddingLeft: "10px",
                transition: "0.20s",
                textAlign: "left",
                "&:focus": {
                    borderRadius: "41px",
                    backgroundColor: "#d3d3d3",
                },
                "&:hover": {
                    backgroundColor: "#d3d3d3",
                },
            },
        },
        MuiMobileStepper: {
            root: {
                backgroundColor: "transparent",
                justifyContent: "center",
            },
            dotActive: {
                backgroundColor: customColors.secondary,
            },
        },
        MuiInput: {
            underline: {
                "&&&&:hover:before": {
                    borderBottom: "1px solid",
                },
            },
        },
        MuiInputBase: {
            root: {
                color: customColors.secondary,
            },
        },
        MuiInputLabel: {
            shrink: {
                transform: "translate(0, 1.5px) scale(0.95)",
            },
        },
        MuiMenuItem: {
            root: {
                fontWeight: 100,
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: "transparent",
            },
            input: {
                padding: "6px 0 7px",
            },
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: "#ffffff",
            },
            barColorPrimary: {
                backgroundColor: customColors.secondary,
            },
        },
        MuiTabs: {
            root: {
                height: "72px",
                backgroundColor: customColors.secondary,
                color: "#ffffff",
            },
            scroller: {
                marginBottom: "0px !important",
            },
            scrollButtons: {
                height: "72px",
            },
            indicator: {
                height: "4px",
                backgroundColor: customColors.tertiary,
            },
        },
        MuiTab: {
            root: {
                height: "72px",
                textTransform: "initial",
                fontSize: "17px !important",
                "&:hover": {
                    color: customColors.tertiary,
                },
                "&$selected": {
                    color: customColors.tertiary,
                },
            },
            textColorInherit: {
                opacity: 1,
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: "0.7em",
            },
        },
        MuiTableCell: {
            body: {
                fontSize: "inherit",
            },
            head: {
                fontSize: "inherit",
            },
        },
        // @ts-expect-error: Unreachable code error
        MuiPickersDay: {
            day: {
                fontSize: "0.9em",
            },
        },
    },
});
